<template>
  <div class="ma-4">
    <ClientNav/>
    <v-row dense>
      <v-col cols="12">
        <v-overlay :value="isLoading && !createMedicationInventory">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-overlay>
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text" v-if="!isLoading || createMedicationInventory">{{ titleForm }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-autocomplete
                    return-object
                    label="Medications"
                    :items="medications"
                    item-value="Medication"
                    item-text="Medication"
                    @change="populateMed"
                    v-model="selectedMedicationItem"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <!-- <v-menu
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="newDateFilled"
                        label="Date Filled"
                        v-on="on"
                        prepend-icon="event"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="newDateFilled" scrollable></v-date-picker>
                  </v-menu> -->
                  <DatePicker
                    :default-date="newDateFilled"
                    v-model="newDateFilled"
                    label="Date Filled"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Medication Name"
                    v-model="newMedication"
                  ></v-text-field>
                </v-col>

                <v-col cols="6" sm="6" md="4">
                  <v-text-field
                    label="Quantity"
                    v-model="newQuantity"
                    :hint="`Previous Quantity: ${previousQuantity == null ? 0 : previousQuantity}` "
                    persistent-hint
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-textarea
                    v-model="newDescription"
                    label="Item Description"
                    outlined
                  ></v-textarea>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-select
                    :items="dosageForm"
                    label="Dosage Form"
                    v-model="newDosageForm"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    label="Strength"
                    v-model="newDosage"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      v-model="newPrescribedBy"
                      :items="providers"
                      item-text="Provider.Name"
                      item-value="Provider._id"
                      label="Prescribed By"
                      class="pa-1 flex-grow-1"
                      clearable
                    ></v-autocomplete>
                    <PrescriberHistoryDialog
                      v-if="!createMedicationInventory"
                      :history="inventory.prescriberHistory"
                    />
                  </div>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="RX Number"
                    class="pa-1"
                    v-model="newRXNumber"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <DatePicker
                    :default-date="newExpirationDate"
                    v-model="newExpirationDate"
                    label="Expiration Date"
                  />
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-file-input
                    v-model="newImage"
                    class="pa-2"
                    label="New Image"
                    filled
                    multiple
                    prepend-icon="mdi-camera"
                    accept="image/*"
                    @change="imgSelected"
                    :readonly="readonly"
                  >
                    <!-- <template #selection="{ text, index }">
                        <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                    </template> -->
                  </v-file-input>
                </v-col>


               <v-carousel v-if="imageDetails.length > 0">
                  <template v-for="(item, index) in imageDetails">
                    <v-carousel-item :key="index">
                      <v-row class="flex-nowrap" style="height:100%">
                        <div v-if="loadingImages[item.AWSLink]" class="loading-container">
                          <div class="loading-content">
                            <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                          </div>
                        </div>
                        
                        <v-img v-else :src="getImageSrc(item)" class="image-container">
                          <v-btn 
                            color="error" 
                            dark 
                            right 
                            @click="removeImage(item, index)" 
                            class="image-btn"
                            :loading="removingImages[item._id]"
                            :disabled="removingImages[item._id]"
                          >
                            <v-icon v-if="!removingImages[item._id]">mdi-delete</v-icon>
                          </v-btn>
                          <v-row class="fill-height" align="center" justify="center">
                            <div style="color: #000;padding-top: 30%;">{{ item.Name }}</div>
                          </v-row>
                        </v-img>
                      </v-row>
                    </v-carousel-item>
                  </template>
                </v-carousel>

                <iframe id="pdf" v-if="pdfDetails.length > 0"
                        style="width: 90%; min-height: 600px; margin: 20px auto;"></iframe>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newEnteredBy"
                    label="Entered By"
                    readonly
                    @click="onAddSignature"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="lastUpdatedBy"
                    label="Last Updated by"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-switch
              v-model="isActive"
              :label="!isActive ? 'Disabled' : 'Enabled'"
              @change="onSwitchStatus(isActive)"
            ></v-switch>

            <v-spacer></v-spacer>

            <div>
              <v-btn class="white--text" color="#259647" @click="addInventory()" :disabled="isSavingImage"
                     v-if="createMedicationInventory && !isAuditorRole">Save
              </v-btn>
              <v-btn fab small @click="showPrintModal()" class="mr-8 mb-2 white--text" color="#2b6993" elevation="4"
                     v-if="!createMedicationInventory && isActive">
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn color="blue darken-1" text @click="updateInventory()" :disabled="isSavingImage"
                     v-if="!createMedicationInventory && isActive && !isAuditorRole">Update
              </v-btn>
            </div>

            <v-btn color="blue darken-1" text @click="close" :disabled="isSavingImage">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../../components/ClientNav'
import Foot from '../../../components/Footer'
import renameFileHelper from '../../../mixins/renameFileHelper';
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import DateTimeUtil from "../../../../utils/date-time.util";
import 'notyf/notyf.min.css';
import PrintUtil from "../../../../utils/print-util";
import {mapActions} from "vuex";
import PrescriberHistoryDialog from '@/components/PrescriberHistoryDialog.vue'
import {displaySuccess, displayError, displayInfo} from "@/service/notification-message.service";
import moment from "moment/moment";
import heicHandler from '@/utils/heicHandler.js';

const url = require("../../../client_config/config").url;

export default {
  mixins: [renameFileHelper],
  components: {
    PrescriberHistoryDialog,
    DatePicker,
    ClientNav,
    Foot,
  },

  data: function () {
    return {
      headers: [
        {
          text: 'Date Filled',
          align: 'start',
          sortable: false,
          value: 'DateFilled',
          width: "15%"
        },
        {text: "Medication", value: "Medication"},
        {text: "Quantity", value: "Quantity"},
        {text: "EnteredBy", value: "EnteredBy"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      tab: null,
      items: ["Medication Inventory", "Disabled Medication Inventory"],
      isActive: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      dialog: false,
      editInventory: false,
      newInventory: false,
      msg: false,
      search: "",
      text: "",
      inventories: [],
      disabledInventories: [],
      tempDataInventories: [],
      tempData: [],
      users: [],
      medications: [],
      selectedMedicationItem: '',
      staff: "",
      clientID: localStorage.getItem("clientId"),
      userID: localStorage.getItem("userID"),
      staffName: localStorage.getItem("Name"),
      titleForm: "New Medication Inventory Entry",
      dosageForm: [
        "Capsule",
        "Chewable",
        "Cream",
        "Drops",
        "Gel",
        "Inhaler",
        "Injection",
        "Liquid",
        "Lotion",
        "Nebulizer",
        "Ointment",
        "Patch",
        "Powder",
        "Solution",
        "Suspension",
        "Suppository",
        "Spray",
        "Tablet",
        "Tablet, chewable",
        "Unknown",
      ],
      inventoryId: this.$route.params.id,
      token: localStorage.getItem('token'),
      inventory: {},
      newDateFilled: "",
      newDescription: "",
      newDosageForm: "",
      newDosage: "",
      newImage: [],
      imageDetails: [],
      pdfDetails: [],
      convertedImages: {},
      loadingImages: {},
      removingImages: {},
      newImageLink: "",
      newEnteredBy: "",
      newMedication: "",
      newQuantity: "",
      med: {},
      defaultItem: {
        dateFilled: "",
        description: "",
        dosage: "",
        image: "",
        enteredBy: "",
        medication: "",
        quantity: ""
      },
      isLoading: true,
      uploadImg: "",
      lastUpdatedBy: "",
      staffID: null,
      previousQuantity: null,
      currentQuantity: null,
      createMedicationInventory: false,
      isSavingImage: false,
      readonly: false,
      downloadUrl: '',
      providers: [],
      newPrescribedBy: "",
      newRXNumber: "",
      newExpirationDate: "",
      prescriberHistoryDialog: false,
    };
  },

  computed: {
    formTitle() {
      return this.createMedication !== 1 ? "New Item" : "Edit Item";
    },

    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 4;
      }

      if (this.$vuetify.breakpoint.lg) {
        return 3;
      }

      if (this.$vuetify.breakpoint.md) {
        return 2;
      }

      return 1;
    },

    userRole() {
      return this.$store.state.users.user.Role === 'Administration'
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },
    clientName() {
      // `this` points to the component instance
      return this.$store.state.clients.client.Name;
    }
  },

  watch: {
    // dialog(val) {
    //   val || this.close();
    // },
    imageDetails() {
      this.convertHeicImages()
    }
  },

  created() {
    this.createMedicationInventory = this.$route.query.createMedicationInventory === 'true';
    this.clientID = this.$route.params.clientID;
    this.getProviders();
  },

  async mounted() {
    await this.getMedications();

    if (!this.createMedicationInventory) {
      await this.getInventory();
    }

    window.addEventListener('keydown', async (event) => {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.handleKeydown(event, downloadUrl, this.inventoryId, this.token, 'MedicationInventory');
    });
  },

  beforeDestroy() {
    window.removeEventListener('keydown', (event) => {
      PrintUtil.handleKeydown(event, this.downloadUrl, this.inventoryId, this.token, 'MedicationInventory');
    });

    Object.values(this.convertedImages).forEach(url => {
      heicHandler.cleanup(url)
    })
  },

  methods: {
    ...mapActions({
      getClientProviders: "clientProviders/getItem",
      generateDynamicReport: "reports/generateDynamicReport",
    }),

    initialize() {
      this.inventories = [];
    },

    viewInventory(item) {

      console.log({item});

      this.titleForm = "Viewing " + item.Medication;
      let checkError = [null, 'Invalid Date', undefined]
      let updatedBy = ''

      if (checkError.includes(item.staffName) || checkError.includes(item.updatedAt)) {
        updatedBy = ''
      } else {
        updatedBy = item.staffName + " - " + DateTimeUtil.toLocalDateTime(item.updatedAt);
      }

      this.newEnteredBy = this.staffName + " - " + new Date();

      if (item.Medication) {
        this.selectedMedicationItem = this.medications.find(med => med.Medication === item.Medication)
      }

      this.newDateFilled = DateTimeUtil.toLocalDate(item.DateFilled);
      this.newDescription = item.Description;
      this.newMedication = item.Medication;
      this.newQuantity = item.Quantity;
      this.newDosageForm = item.DosageForm;
      this.newDosage = item.Dosage;
      this.lastUpdatedBy = updatedBy
      this.previousQuantity = item.PreviousQuantity === undefined ? 0 : item.PreviousQuantity
      this.currentQuantity = item.Quantity;
      this.newPrescribedBy = item.PrescribedBy
      this.newRXNumber = item.RXNumber;
      this.newExpirationDate = DateTimeUtil.toLocalDate(item.ExpirationDate);

      if (item.documents.length > 0) {
        const tempData = [];

        for (let i = 0; i < item.documents.length; i++) {
          tempData.push({
            name: item.documents[i].Name,
          });

          let fileExt = item.documents[i].AWSLink.split('.').pop();

          if (fileExt === "pdf") {
            this.pdfDetails.push(item.documents[i].AWSLink);
          } else {
            this.imageDetails.push(item.documents[i]);
          }
        }

        this.newImage = tempData;
      }

      this.inventoryId = item._id;
      this.isActive = item.IsActive;

      if (item.EnteredBy !== "") {
        this.newEnteredBy = item.EnteredBy;
        if(this.newEnteredBy.includes("Z")){
          this.newEnteredBy = this.formatSignature(this.newEnteredBy);
        }
      }
    },

    onAddSignature() {
      this.newEnteredBy = this.staffName + " - " + moment().utc().toISOString();
    },

    clear() {
      this.newDateFilled = "";
      this.newDescription = "";
      this.newImage = [];
      this.newImageLink = "";
      this.newMedication = "";
      this.newQuantity = "";
      this.newEnteredBy = "";
      this.newDosageForm = "";
      this.newDosage = "";
      this.imageDetails = [];
      this.providers = [];
      this.newPrescribedBy = "";
      this.newRXNumber = "";
      this.newExpirationDate = "";
    },

    close() {
      this.$router.go(-1);
      this.clear()
      this.$nextTick(() => {
        this.getInventories();
      });
    },

    async updateInventory() {
      this.isLoading = true;

      let request_body = {
        DateFilled: DateTimeUtil.toUTCISOString(this.newDateFilled),
        Description: this.newDescription,
        //Image: this.newImage,
        EnteredBy: this.newEnteredBy,
        Medication: this.newMedication,
        Quantity: this.newQuantity,
        DosageForm: this.newDosageForm,
        Dosage: this.newDosage,
        PrescribedBy: this.newPrescribedBy,
        RXNumber: this.newRXNumber,
        ExpirationDate: this.newExpirationDate,
        StaffID: this.userID,
        ClientID: this.clientID,
        PreviousQuantity: this.currentQuantity
      };

      try {
        const response = await axios.put(`${url}/medicationInventory/${this.inventoryId}`, request_body);

        if (response.status !== 200) {
          displayError("There was an error updating the document.");
          return;
        }

        if (this.uploadImg.length) {
          this.isSavingImage = true;
          displayInfo("Uploading image, please wait...");
          await this.saveImg();
        }

        displaySuccess("The document has been updated successfully.");

      } catch (error) {
        displayError(error.response && error.response.data && error.response.data.msg || "An unexpected error occurred.");
      } finally {
        this.isSavingImage = false;
        this.isLoading = false;
        this.close();
      }
    },

    getInventory() {
      this.isLoading = true;

      axios.get(`${url}/medicationInventory/${this.inventoryId}`).then(response => {
        this.inventory = response.data
        this.viewInventory(this.inventory);
      }).finally(() => this.isLoading = false);
    },

    getInventories() {
      this.isLoading = true;

      axios.get(`${url}/medicationInventory/client/${this.clientID}`).then(res => {
        this.inventories = [];
        this.disabledInventories = [];
        this.tempDataInventories = res.data.inventories;

        for (let i = 0; i < this.tempDataInventories.length; i++) {
          let dt = new Date(this.tempDataInventories[i].DateFilled);
          this.tempDataInventories[i].DateFilled = dt.toISOString().substring(0, 10)

          if (this.tempDataInventories[i].IsActive === true || this.tempDataInventories[i].IsActive === undefined) {
            this.inventories.push(this.tempDataInventories[i]);
          }

          if (this.tempDataInventories[i].IsActive === false) {
            this.disabledInventories.push(this.tempDataInventories[i])
          }

        }
      }).finally(() => this.isLoading = false);
    },

    async addInventory() {
      let request_body = {
        DateFilled: DateTimeUtil.toUTCISOString(this.newDateFilled),
        Description: this.newDescription,
        //Image: this.newImage,
        EnteredBy: this.newEnteredBy,
        ClientID: this.clientID,
        Medication: this.newMedication,
        Quantity: this.newQuantity,
        DosageForm: this.newDosageForm,
        Dosage: this.newDosage,
        PrescribedBy: this.newPrescribedBy,
        RXNumber: this.newRXNumber,
        ExpirationDate: this.newExpirationDate,
        StaffID: this.userID,
      };

      try {
        const response = await axios.post(`${url}/medicationInventory`, request_body);
        this.inventoryId = response.data._id;

        if (response.status !== 201) {
          displayError("There was an error adding the document.");
          return;
        }

        if (this.uploadImg.length) {
          this.isSavingImage = true;
          displayInfo("Uploading image, please wait...");
          await this.saveImg();
        }
        displaySuccess("The document has been created successfully.");
      } catch (error) {
        displayError("Failed to upload image: " + (error.response && error.response.data && error.response.data.msg || "An unexpected error occurred."));
      } finally {
        this.isSavingImage = false;
        this.isLoading = false;
        this.close();
      }
    },

    async getMedications() {
      try {
        const response = await axios.get(`${url}/medications/all/${this.clientID}`);
        this.medications = response.data.medications;
      } catch (error) {
        console.error('Failed to get medications:', error);
      }
    },

    async imgSelected(e) {
      this.uploadImg = await this.renameFileHelper(e, this.clientName, "MedicationInventory");
    },

    saveImg() {
      this.message = "";

      for (let i = 0; i < this.uploadImg.length; i++) {
        this.uploadFiles(this.uploadImg[i]);
      }
    },

    uploadFiles(file) {
      const formData = new FormData();
      formData.append('inventory-img', file);
      var ct = {headers: {"content-type": "multipart/form-data"}};

      axios.post(`${url}/medicationInventory/imguploader/${this.inventoryId}/${this.clientID}`, formData, ct)
        .then(res => {
          console.log({res})
        })
        .catch(err => {
          console.log(err);
        });
    },

    deleteChip(index) {
      // Prompt here with text if required
      this.newImage.splice(index, 1);
    },

    populateMed(item) {
      this.newDescription = item.Description;
      this.newMedication = item.Medication;
      this.newDosageForm = item.DosageForm;
      this.newDosage = item.Dosage;
    },


    onSwitchStatus(e) {
      let req_body = {
        IsActive: e,
      };

      axios
        .put(`${url}/medicationInventory/status/${this.inventoryId}`, req_body)
        .then((response) => {
          this.getInventories();

          if (response.status === 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }

          this.clear();
          this.msg = true;

          if (e) {
            this.text = "Medication Change status to Active";
          } else {
            this.text = "Medication Successfully Discontinued";
          }
        })
        .finally(() => this.close());
    },

    async removeImage(item, i) {
      this.$set(this.removingImages, item._id, true)
      
      try {
        await axios.put(`${this.url}/documents/${item._id}/status`, { status: 0 })
        
        if (this.convertedImages[item.AWSLink]) {
          heicHandler.cleanup(this.convertedImages[item.AWSLink])
          this.$delete(this.convertedImages, item.AWSLink)
        }
        
        this.$delete(this.loadingImages, item.AWSLink)
        this.$delete(this.removingImages, item._id)
        
        this.imageDetails.splice(i, 1)
        
      } catch (error) {
        console.error('Failed to remove image:', error)
      } finally {
        this.$set(this.removingImages, item._id, false)
      }
    },

    async generateDownloadUrl() {
      return `${url}/medicationInventory/print?id=${this.inventoryId}`;
    },

    async showPrintModal() {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.showPrintOption(downloadUrl, this.inventoryId, this.token, 'MedicationInventory');
    },

    async getProviders() {
      try {
        const response = await this.getClientProviders(this.clientID);
        this.providers = (response?.data || [])
          .filter(item => item.Provider && item.Provider.Name)
          .sort((a, b) => {
            return (a.Provider?.Name || '').localeCompare(b.Provider?.Name || '');
          });
      } catch (error) {
        console.error('Failed to fetch providers:', error);
        this.providers = [];
      }
    },

    formatSignature(enteredBy) {
      if (!enteredBy || enteredBy === "") {
        return "";
      }

      if (enteredBy.includes("Z")) {
        const [name, utcTime] = enteredBy.split(" - ");
        const cleanUtcTime = utcTime.replace("Z", ""); // Remove "Z" for parsing
        const localTime = moment.utc(cleanUtcTime, "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD HH:mm");
        return `${name} - ${localTime}`;
      }

      return enteredBy;
    },

     getImageSrc(item) {
      return this.convertedImages[item.AWSLink] || item.AWSLink
    },

    async convertHeicImages() {
      for (let item of this.imageDetails) {
        if (heicHandler.isHeic(item.Name) && !this.convertedImages[item.AWSLink]) {
          this.$set(this.loadingImages, item.AWSLink, true)
          
          try {
            const convertedUrl = await heicHandler.convert(item.AWSLink)
            if (convertedUrl) {
              this.$set(this.convertedImages, item.AWSLink, convertedUrl)
            }
          } catch (error) {
            console.error('Failed to convert HEIC:', error)
          } finally {
            this.$set(this.loadingImages, item.AWSLink, false)
          }
        }
      }
    },
  },
};

</script>

<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

.v-image__image--cover {
  background-size: contain;
}


.image-container {
  position: relative;
}

.image-btn {
  position: absolute;
  top: 25px;
  right: 25px;
}

.loading-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-text {
  font-size: 16px;
  color: #666;
  text-align: center;
}
</style>
